import axios from '../../../build/http-requests/axios-common'
import generateDateTime from '../../utils/generateDateTime'
import Vue from 'vue'

export default {
  state: {
  },

  mutations: {
  },

  actions: {
    searchConciliationSummary: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/conciliationSummary/search', filter).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    searchConciliationSummaryToFile: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/conciliationSummary/searchConciliationSummaryToFile', filter, {responseType: 'blob'}).then(response => {
          let datetime = generateDateTime()
          let blob = new Blob([response.data])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.setAttribute('download', Vue.i18n.translate('downloads.labels.resumoConciliacao') + datetime + '.csv')
          document.body.appendChild(link)
          link.click()
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/conciliationSummary.js